import React from "react";
import PropTypes from "prop-types";
import CmsImageText from "@/bit/components/components.cms-block.cms-image-text";
import TextInfo from "@/bit/components/components.text";
import emptyMock from "./emptyMock.json";
import getColor from "@gcloud-npm/utils.enums.colors";

const CmsImageTextList = (props) => {
  const {
    cmsHandler = null,
    blockName,
    alias,
    CmsAddElement,
    CmsEditableGroupIcons,
  } = props;

  const titleProps = props["cms-atom-text-1"];
  const imageTextList = props["cms-ml-image-text-list-1"];

  const color = props.color || "white";
  const backgroundColor = getColor(color);

  if (
    !imageTextList ||
    !Array.isArray(imageTextList) ||
    (imageTextList.length === 0 && !process.env.NEXT_PUBLIC_ASTRO_MAKER)
  ) {
    return null;
  }

  // Add Element Props
  const addProps = {
    contentId: blockName,
    itemIdDotNotation: `${blockName}.cms-ml-image-text-list-1`,
    layout: "vertical",
  };

  return (
    <section
      id={blockName || ""}
      className={`image-text-module container`}
      style={{ backgroundColor: backgroundColor }}
    >
      {/* TITULO */}
      {titleProps && (
        <div className="image-text--title">
          <TextInfo
            {...titleProps}
            kind="h"
            level="2"
            cyData="Image-text Title"
            cmsHandler={cmsHandler}
          />
        </div>
      )}
      {/* AÑADIR ELEMENTO */}
      {CmsAddElement && (
        <CmsAddElement
          addProps={{
            index: "start",
            ...addProps,
          }}
          cmsHandler={cmsHandler}
        />
      )}
      {/* LISTA DE ELEMENTOS */}
      {imageTextList.length === 0 ? (
        <CmsImageText {...emptyMock} />
      ) : (
        imageTextList.map((row, index) => (
          <CmsImageText
            {...row}
            key={`cms-image-text-${index}`}
            index={index}
            blockName={blockName}
            alias={alias}
            CmsEditableGroupIcons={CmsEditableGroupIcons}
            frontalListToDelete={imageTextList}
            cmsHandler={cmsHandler}
          />
        ))
      )}
      {/* AÑADIR ELEMENTO */}
      {CmsAddElement && (
        <CmsAddElement
          addProps={{
            index: "end",
            ...addProps,
          }}
          cmsHandler={cmsHandler}
        />
      )}
      <style jsx>{`.image-text-module {
  .image-text--title {
    padding-bottom: 2rem;
  }
}
`}</style>
    </section>
  );
};

export default CmsImageTextList;

CmsImageTextList.propTypes = {
  /**
   * {
   *  "info": "Color del fondo.",
   *  "kind": "both",
   *  "beautifulName": "Color del fondo"
   * }
   */
  color: PropTypes.string,
};

CmsImageTextList.defaultProps = {
  color: "",
};
